import { useEffect, useState } from 'react';
import { Trans, t } from '@lingui/macro';
import { AvatarWithLabel, List, ListSubHeader, Switch } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { Source } from './Source';
import { StyledListItem } from './styled';
export function Sources({ docHighlights }) {
    const [showAll, setShowAll] = useState(false);
    const [highlights, setHighlights] = useState(() => docHighlights.map(docHighlight => [docHighlight.isActive(), docHighlight]));
    const updateActiveStates = () => setHighlights(prev => prev.map(([, hl]) => [hl.isActive(), hl]));
    useEffect(() => () => docHighlights.forEach(hl => hl.highlightOff()), [docHighlights]);
    return (<List>
      <ListSubHeader>
        <Trans comment="Plai Drawer - Issue - Sources">Sources</Trans>
      </ListSubHeader>
      <StyledListItem>
        <AvatarWithLabel appearance="secondary" size="sm" title={t({
            message: 'Preview all',
            comment: 'Plai Drawer - Issue - Sources - preview all button - label',
        })}>
          <Falcon icon="eye"/>
        </AvatarWithLabel>
        <Switch checked={showAll} onClick={() => {
            var _a;
            if (showAll) {
                setShowAll(false);
                docHighlights.forEach(docHighlight => docHighlight.highlightOff());
            }
            else {
                setShowAll(true);
                // only scroll to first highlight
                (_a = docHighlights[0]) === null || _a === void 0 ? void 0 : _a.highlightOn();
                // highlight all other highlights without scrolling
                docHighlights.slice(1).forEach(docHighlight => docHighlight.highlightOn(false));
            }
            updateActiveStates();
        }}/>
      </StyledListItem>
      {highlights.map(([isActive, docHighlight]) => (<Source key={docHighlight.text} text={docHighlight.text} isActive={isActive} on={() => {
                if (!isActive) {
                    docHighlight.highlightOn();
                    updateActiveStates();
                }
            }} off={() => {
                if (isActive) {
                    docHighlight.highlightOff();
                    setShowAll(false);
                    updateActiveStates();
                }
            }}/>))}
    </List>);
}
